import "./GoalCard.css";

const GoalCard = ({ title, bgColor, icon }) => {
  return (
    <div style={{ backgroundColor: bgColor }} className="goal-card">
      {icon}
      <p style={{ textAlign: "center", marginTop: "10px" }}>{title}</p>
    </div>
  );
};

export default GoalCard;
